import React from 'react';
import { CollectionItem, collectionStatusColors } from '../accountingTypes';
import styles from './TodaysCollections.module.css';

interface TodaysCollectionsProps {
  items: CollectionItem[];
}

export const TodaysCollections: React.FC<TodaysCollectionsProps> = ({ items }) => {
  return (
    <div className={styles.wrapper}>
      <h3 className={styles.title}>Today's Collections</h3>
      <div className={styles.list}>
        {items.map((item, idx) => {
          const sc = collectionStatusColors[item.status];
          return (
            <div key={idx} className={styles.row}>
              <div className={styles.left}>
                <div className={styles.avatar} style={{ background: item.avatarBg }}>
                  {item.initials}
                </div>
                <div className={styles.info}>
                  <span className={styles.repName}>{item.rep}</span>
                  <span className={styles.paymentCount}>{item.paymentCount} payment{item.paymentCount !== 1 ? 's' : ''}</span>
                </div>
              </div>
              <div className={styles.right}>
                <span className={styles.amount} style={{ color: sc.color }}>{item.amount}</span>
                <span className={styles.status} style={{ color: sc.color }}>↑ {item.status}</span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
